import { Point } from "highcharts";
import { AccumulatedCost, BudgetPeriod } from "@/services/cloudchipr.api";
import { formatDate } from "@/utils/helpers/date-time/datetime-format";
import { money } from "@/utils/numeral/money";

export const getBudgetDetailsAccumulatedCostChartTooltipValueGetter = (
  budget: number = 0,
  allCosts?: AccumulatedCost,
  period?: BudgetPeriod,
) => {
  return (point: Point) => {
    const date = point?.category;
    const cost = allCosts?.costs?.at(point.index)?.cost ?? 0;

    return `
      <div style="min-width: 210px">
        <div style="font-size: 13px; color: #666; margin-bottom: 8px">
            ${formatDate(String(date), { type: period === "annually" ? "monthNameYear" : "date" })}
        </div>  
        
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px">
          <span
            style="
              display: flex;
              align-items: center;
              font-size: 11px;
              margin-right: 16px;
            "
          >
            <span
              style="font-weight: 400; font-size: 12px; word-break: break-word; white-space: normal; color: #000"
            >
              Accumulated Cost
            </span>
          </span>
          
          <div
            style="display: flex; flex-direction: row; align-items: center"
          >
            <span style="font-weight: 500; font-size: 12px; margin-right: 4px">
              ${money(cost)}
            </span>
          </div>
        </div>
        
        <div style="display: flex; justify-content: space-between; align-items: center">
          <span
            style="
              display: flex;
              align-items: center;
              font-size: 11px;
              margin-right: 16px;
            "
          >
            <span
              style="font-weight: 400; font-size: 12px; width:${point.series.name.length * 10}px; max-width: 250px; min-width: 35px; word-break: break-word; white-space: normal; color: #000"
            >
              Budget
            </span>
          </span>
          
          <div
            style="display: flex; flex-direction: row; align-items: center"
          >
            <span style="font-weight: 500; font-size: 12px; margin-right: 4px">
              ${money(budget)}
            </span>
          </div>
        </div>
      </div>
    `;
  };
};
